import React from 'react';

const TableRow = ({ row: { parsed_data, original_data }, headers, options, F_options, number, position }: any) => {

    let value1: any;
    value1 = options

    const { showOpt, selectOpt } = F_options

    const data = Object.keys(parsed_data).map((key) => parsed_data[key]);

    const getExtention = (url: string) => url.split('.').pop();

    const downloadFile = (url: string) => {
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.click();
    };

    return (
        <>
            {(headers[number].column_type === 'image') ?
                <div className="imageName">
                    <img src={data[number]} alt={data[number]} className="imgPhoto" />
                </div> :
                (headers[number].column_type === 'file') ?
                    <div
                        className="spaceFile"
                        onClick={() => downloadFile(data[number])}
                        style={{ cursor: 'pointer' }}
                        title={''}
                    >
                        <div className={`file ${getExtention(data[number])}`}>
                            <span>{getExtention(data[number])}</span>
                            <i className="fas fa-cloud-download-alt"></i>
                        </div>
                        <div className="corner" />
                    </div> :
                    (headers[number].column_type === 'options') ?
                        <div className="action">
                            <div onClick={() => selectOpt(position)}>
                                <i className="fas fa-ellipsis-h pointer" />
                            </div>
                            <div className={`select ${showOpt === position ? 'show' : ''}`}>
                                {
                                    data[number].map((opt: any, k: number) =>
                                        <p key={k} onClick={() => opt.onClick(original_data)} >{opt.label}</p>)
                                }
                            </div>
                        </div>
                        :
                        <p>
                            {data[number]}
                        </p>

            }
        </>
    )
}

export default TableRow
